import { createContext, useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useAblyChannel } from '@poplar/hooks/useAblyChannel';
import { useUser } from '@poplar/hooks/useUser';
import { stripQueryParams } from '@poplar/utils/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var AblyContext = /*#__PURE__*/createContext(undefined);
export var AblyProvider = function AblyProvider(_ref) {
  var _user$profile;

  var children = _ref.children;
  var user = useUser();
  var router = useRouter();
  var currentUrlRef = useRef(stripQueryParams(router.asPath));

  var _useState = useState(null),
      data = _useState[0],
      setData = _useState[1];
  /**
   * Subscribe to ably channel and format response
   */


  var _useAblyChannel = useAblyChannel(user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.userId, function (res) {
    var payload = JSON.parse(res.data);
    setData({
      type: res.name,
      clientId: res.clientId,
      payload: payload
    });
  }),
      channel = _useAblyChannel.channel,
      error = _useAblyChannel.error;
  /**
   * <AblyProvider/> is the parent of <TaskProvider/> in <MainLayout/>.
   * We force the <TaskProvider key={router.asPath}/> to re-render when application route changes.
   * This makes sure we reset ably event data to null when navigation between pages.
   * If left unchanged, the <AblyProvider/> will keep the previous old data and pass that down to its children,
   * causing unwanted and repeated behavior.
   */


  useEffect(function () {
    var handleRouteChange = function handleRouteChange(targetUrl) {
      var targetUrlWithoutParams = stripQueryParams(targetUrl); // Clear only if the pathnames do not match (after removing qps)

      if (targetUrlWithoutParams !== currentUrlRef.current) {
        setData(null);
        currentUrlRef.current = targetUrlWithoutParams;
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);
    return function () {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router.events]);
  return /*#__PURE__*/_jsx(AblyContext.Provider, {
    value: {
      error: error,
      loading: !!channel,
      data: data
    },
    children: children
  });
};